import { takeLatest, put, call, select } from 'redux-saga/effects';
import { ESTABLISHMENT_LIST_SAGA } from "../sagaTypes";
import { loaderAction, establishmentListAction, debtAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";

const request = data => {
    return fetch(`${ url }/establishment_list`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerEstablishmentList() {
    const user = yield select(state => state.user);
    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            yield put(establishmentListAction(response.establishment_list));
            yield put(debtAction(response.debt));
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherEstablishmentList() {
    yield takeLatest(ESTABLISHMENT_LIST_SAGA, workerEstablishmentList);
}